import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { Paper, Table, TableRow, TableCell, TableHead, TableBody, makeStyles, CircularProgress, Box, } from '@material-ui/core';
import clsx from 'clsx';
import { createHeaderColumn, useModeTableStyle, useModePanelStyle, } from '../../..';
import { createPreviewItemCell, createRemoveItemCell, } from '../../componentUtils';
import { CompPanelHeader, } from '../compPanelHeader';
const useStyle = makeStyles((theme) => {
    return {
        panelHeaderIcon: {},
        panelContent: {
            padding: 0,
            height: '100%',
            display: 'flex',
            flexDirection: 'column',
        },
        tableContainer: {
            overflow: 'auto',
            flex: 1,
        },
        tableCol: {
            '&.id-col': {
                textAlign: 'center',
            },
            '&.deviceClass-col': {
                textAlign: 'left',
            },
            '&.tag-col': {
                textAlign: 'left',
                width: '50%',
            },
            '&.name-col': {
                textAlign: 'left',
                width: '50%',
            },
            '&.status-col': {
                textAlign: 'center',
                '& .value': {
                    fontSize: 'smaller',
                    fontWeight: 500,
                    padding: theme.spacing(0.3, 1),
                    borderRadius: 100,
                    textTransform: 'lowercase',
                    width: '100%',
                    display: 'inline-block',
                },
                '&.connected': {
                    '& .value': {
                        background: theme.palette.success.main,
                        color: theme.palette.success.contrastText,
                    },
                },
                '&.disconnected': {
                    '& .value': {
                        background: theme.palette.error.main,
                        color: theme.palette.error.contrastText,
                    },
                },
            },
            '&.connectivityDate-col': {
                textAlign: 'left',
            },
            '&.claimTime-col': {
                textAlign: 'left',
            },
        },
        addDeviceButton: {
            backgroundColor: theme.palette.success.main,
            color: theme.palette.success.contrastText,
            marginLeft: theme.spacing(1),
            '&:hover': {
                backgroundColor: theme.palette.success.light,
            },
        },
    };
}, {
    name: 'HomeDevicesTable', index: 1,
});
/**
 * This is a DUMB component that is in charge of displaying the list of devices with pagination. All this component does is display data
 * provided through props. This component does not have any logic and any user action will be dispatched to the container's handlers.
 */
export const HomeDevicesTable = (props) => {
    const tableClasses = useModeTableStyle();
    const panelClasses = useModePanelStyle();
    const classes = useStyle();
    return (_jsxs(Paper, { elevation: 2, className: clsx(panelClasses.root, props.className, props.showCustomActionOnHover && 'show-custom-action-on-hover'), children: [_jsx(CompPanelHeader, { ...props }), _jsxs("div", { className: clsx(panelClasses.panelContent, classes.panelContent), children: [props.listData && props.listData.length > 0 && (_jsxs(_Fragment, { children: [_jsx("div", { className: classes.tableContainer, children: _jsxs(Table, { className: tableClasses.root, size: "medium", children: [_jsx(TableHead, { className: tableClasses.tableHeader, children: _jsx(TableRow, { className: tableClasses.tableHeaderRow, children: Object.keys(props.fieldsSettings.fields).filter((fieldName) => {
                                                    var _a;
                                                    return !((_a = props.fieldsSettings.fields[fieldName]) === null || _a === void 0 ? void 0 : _a.hidden);
                                                }).map((fieldName) => {
                                                    const field = props.fieldsSettings.fields[fieldName];
                                                    if (field && !field.hidden) {
                                                        return createHeaderColumn(props.fieldsSettings, fieldName, field, `${tableClasses.tableCol} ${classes.tableCol} ${fieldName}-col`);
                                                    }
                                                    return _jsx(_Fragment, {});
                                                }) }) }), _jsx(TableBody, { children: props.listData.map((dataItem) => {
                                                return (_jsx(TableRow, { className: clsx(tableClasses.tableBodyRow, 'clickable', dataItem.selected && 'selected'), onClick: () => {
                                                        if (props.onListItemSelected) {
                                                            props.onListItemSelected(dataItem.actualValue);
                                                        }
                                                    }, children: Object.keys(props.fieldsSettings.fields).filter((fieldName) => {
                                                        var _a;
                                                        return !((_a = props.fieldsSettings.fields[fieldName]) === null || _a === void 0 ? void 0 : _a.hidden);
                                                    }).map((fieldName) => {
                                                        if (fieldName === 'status' && props.fieldsSettings.fields.status
                                                            && !props.fieldsSettings.fields.status.hidden) {
                                                            return (_jsx(TableCell, { className: clsx(tableClasses.tableCol, classes.tableCol, `${fieldName}-col`, dataItem.actualValue.isConnected ? 'connected' : 'disconnected'), children: _jsx("div", { className: "value", children: dataItem.displayValue.status }) }, fieldName));
                                                        }
                                                        if (fieldName === 'remove' && props.fieldsSettings.fields.remove
                                                            && !props.fieldsSettings.fields.remove.hidden) {
                                                            return (
                                                            // NOTE: dataItem.canBeRemoved must be true
                                                            createRemoveItemCell(dataItem, clsx(tableClasses.tableCol, classes.tableCol, `${fieldName}-col`), props.onRemoveItemClicked));
                                                        }
                                                        if (fieldName === 'preview' && props.fieldsSettings.fields.preview
                                                            && !props.fieldsSettings.fields.preview.hidden) {
                                                            return createPreviewItemCell(dataItem, clsx(tableClasses.tableCol, classes.tableCol, `${fieldName}-col`), props.onPreviewItemClicked);
                                                        }
                                                        /**
                                                         * Handle all the other fields that don't have special UI. These are the fields that
                                                         * display dataItem.displayValue as plain text
                                                         */
                                                        if (props.fieldsSettings.fields[fieldName]
                                                            && !props.fieldsSettings.fields[fieldName].hidden) {
                                                            return (_jsx(TableCell, { className: clsx(tableClasses.tableCol, classes.tableCol, `${fieldName}-col`), children: dataItem.displayValue[fieldName] }, fieldName));
                                                        }
                                                        return _jsx(_Fragment, {});
                                                    }) }, dataItem.actualValue.id));
                                            }) })] }) }), props.paginationComp] })), props.listData && props.listData.length === 0 && props.emptyDataMessageComp, !props.listData && (_jsx(Box, { padding: 2, children: _jsx(CircularProgress, {}) }))] })] }));
};
